// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.inputCheckboxLabel {
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 14px;
}

.mediaStop {
  height: 140px;
  width: 251px;
  margin-bottom: 20px;
}

.accordion {
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 60px;
}

.tab-nav {
  width: max-content;
}

@media only screen and (min-width: 1024px) and (max-width: 1220px) {
  .tab-nav .app-tab .list a {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 1221px) and (max-width: 1250px) {
  .tab-nav .app-tab .list a {
    font-size: 1.8rem;
  }
}
@media only screen and (min-width: 1251px) and (max-width: 1273px) {
  .tab-nav .app-tab .list a {
    font-size: 1.9rem;
  }
}
.accounts-tab {
  margin: 0 16.66%;
}
.accounts-tab h3 {
  font: 24px "Omnes-ATT-W02";
  margin-top: 30px;
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  .accounts-tab h3 {
    font: 16px "Omnes-ATT-W02-Medium";
  }
}
.accounts-tab .icon-arrows-sort-arrow {
  font-size: 17px !important;
}
.accounts-tab .search {
  position: relative;
}
.accounts-tab .search input {
  padding-right: 40px;
}
.accounts-tab .search .search-icon {
  cursor: pointer;
  margin-top: -10px;
  position: absolute;
  right: 20px;
  top: 50%;
}
.accounts-tab .search .search-icon .icon-controls-magnifyingglass {
  color: #c4c4c4;
  font-size: 25px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: -2px;
}
.accounts-tab .search .search-icon .icon-close {
  color: #c4c4c4;
  font-size: 25px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: -2px;
}
.accounts-tab .search #searchField::-ms-clear {
  display: none;
}
.accounts-tab .search-label {
  display: none;
}
.accounts-tab .rowdisabled {
  pointer-events: none;
}
.accounts-tab .box-outer {
  padding: 0 30px;
}
.accounts-tab .tab-content {
  padding: 0;
}
.accounts-tab .tab-content h2 {
  font-size: 3rem;
  font-weight: normal;
  margin: 30px 0;
}
.accounts-tab .tab-content p {
  margin-bottom: 20px;
}
.accounts-tab .acc-content table {
  margin: 0;
}
.accounts-tab .acc-content table tbody:last-child td {
  border-bottom: 0 !important;
}
.accounts-tab tr th:first-child {
  width: 15%;
}
.accounts-tab .accounts {
  margin-bottom: 30px;
}
.accounts-tab .buttons-section {
  margin-top: 20px;
  border-top: 1px solid #d2d2d2;
  padding: 30px 0;
}
.accounts-tab .buttons-section .btn-cancel {
  margin-right: 30px;
}
@media (max-width: 1024px) {
  .accounts-tab .buttons-section {
    margin-top: 20px;
  }
}
.accounts-tab .check {
  margin-bottom: 30px;
}
.accounts-tab .check .checkbox {
  display: block;
}
.accounts-tab .error-text {
  color: hsl(0, 66%, 49%);
}
.accounts-tab .error-text .skin {
  border: 1px solid hsl(0, 66%, 49%);
}
.accounts-tab .modal-header {
  margin-bottom: 10px;
}
.accounts-tab .terms-and-conditions .checkbox a {
  color: #191919;
}
.accounts-tab .terms-and-conditions .row {
  margin-left: 0;
  margin-right: 0;
}
.accounts-tab .terms-and-conditions .form-group {
  margin-left: 0;
  margin-right: 0;
}
.accounts-tab .terms-and-conditions .terms h1 {
  margin-top: 30px;
}
.accounts-tab .agreement {
  margin-top: 15px;
}
.accounts-tab .agreement h2 {
  font-size: 20px;
}
.accounts-tab .agreement .attTerms {
  padding-bottom: 10px;
}
.accounts-tab .agreement p {
  margin-bottom: 0;
  display: inline;
}
.accounts-tab .agreement .termsServiceText p {
  margin-bottom: 0;
  display: inline;
}
.accounts-tab .signupwithnotab .agreement {
  border-top: 1px solid #d2d2d2;
  margin-top: 30px;
}
.accounts-tab .signupwithnotab .agreement h3 {
  margin-bottom: 20px;
}
.accounts-tab .signuptabcontainer {
  position: relative;
}
.accounts-tab .signuptabcontainer .pagination::after {
  border: 0 none;
  height: 0;
  width: 0;
}
.accounts-tab .alert {
  margin-bottom: 30px;
}
.accounts-tab .fan-profile {
  cursor: pointer;
}
.accounts-tab .terms-of-service-container {
  border-top: 1px solid #d2d2d2;
}
.accounts-tab .terms-of-service-container .checkbox:first-child {
  margin-bottom: 20px;
}
.accounts-tab .ineligible-fans {
  color: hsl(0, 66%, 49%);
}
.accounts-tab .attTerms,
.accounts-tab .ibmTerms {
  margin-bottom: 20px;
  font-size: 16px;
  font-family: Omnes-ATT-W02, Arial;
}
@media (max-width: 1024px) {
  .accounts-tab {
    margin: 0 15px;
  }
  .accounts-tab .accordion {
    margin-bottom: 30px;
  }
  .accounts-tab .tab-nav {
    width: unset;
  }
  .accounts-tab .signup-section .tabContainer {
    height: max-content;
  }
  .accounts-tab .btn-cancel {
    margin: 20px 0;
    text-align: center;
    width: 100%;
  }
  .accounts-tab .btn {
    text-align: center;
    width: 100%;
  }
  .accounts-tab .buttons-section {
    padding: 20px 0 0;
  }
  .accounts-tab .buttons-section .btn-cancel {
    margin: 20px 0 30px;
  }
  .accounts-tab .tab-nav .app-tab .list > a {
    padding: 25px 1px !important;
    color: #191919 !important;
  }
  .accounts-tab .tab-content h2,
  .accounts-tab .tab-content p {
    margin-bottom: 20px !important;
  }
  .accounts-tab .accounts,
  .accounts-tab .check {
    margin-bottom: 20px;
  }
  .accounts-tab .form-group {
    margin-bottom: 20px;
  }
  .accounts-tab .agreement p {
    margin-bottom: 0 !important;
  }
  .accounts-tab .grid-table {
    margin-left: -15px;
    margin-right: -15px;
  }
  .accounts-tab .step-indicator,
  .accounts-tab .alert {
    margin-bottom: 30px !important;
  }
}
.accounts-tab .search-field {
  float: right;
}
.accounts-tab .link-to-brief {
  margin: 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup/accounts/accounts.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,mCAAA;EACE,eAAA;AAmJN;;AA1IA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AA6IJ;;AA3IA;EACQ,gCAAA;EACA,mBAAA;AA8IR;;AA3IA;EAEI,kBAAA;AA6IJ;;AA1IA;EAIU;IACE,iBAAA;EA0IV;AACF;AArIA;EAIQ;IACE,iBAAA;EAoIR;AACF;AA/HA;EAIQ;IACE,iBAAA;EA8HR;AACF;AArHA;EACE,gBAAA;AAuHF;AA3GE;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;AA6GJ;AFtKI;EEsDF;IAKI,iCAAA;EA+GJ;AACF;AA7GE;EACM,0BAAA;AA+GR;AA7GI;EACI,kBAAA;AA+GR;AA9GQ;EACI,mBAAA;AAgHZ;AA9GQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAgHZ;AA/GY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAiHhB;AA/GY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAiHhB;AA9GI;EACE,aAAA;AAgHN;AA5GE;EACE,aAAA;AA8GJ;AA3GI;EACI,oBAAA;AA6GR;AA3GI;EACI,eAAA;AA6GR;AA3GI;EACI,UAAA;AA6GR;AA5GQ;EACI,eAAA;EACA,mBAAA;EACA,cAAA;AA8GZ;AA5GQ;EACI,mBAAA;AA8GZ;AA1GQ;EACI,SAAA;AA4GZ;AA3GY;EACI,2BAAA;AA6GhB;AAvGY;EACI,UAAA;AAyGhB;AArGI;EACI,mBAAA;AAuGR;AArGI;EACI,gBAAA;EACA,6BAAA;EACA,eAAA;AAuGR;AAtGQ;EACI,kBAAA;AAwGZ;AFpPI;EEuIA;IAQQ,gBAAA;EAyGV;AACF;AAvGI;EACI,mBAAA;AAyGR;AAxGQ;EACI,cAAA;AA0GZ;AAvGI;EACI,uBAAA;AAyGR;AAxGQ;EACI,kCAAA;AA0GZ;AAvGI;EACI,mBAAA;AAyGR;AArGY;EACI,cAAA;AAuGhB;AApGQ;EACI,cAAA;EACA,eAAA;AAsGZ;AApGQ;EACI,cAAA;EACA,eAAA;AAsGZ;AAnGY;EACI,gBAAA;AAqGhB;AAjGI;EAEI,gBAAA;AAkGR;AAjGQ;EACI,eAAA;AAmGZ;AAjGU;EACE,oBAAA;AAmGZ;AA9FQ;EACI,gBAAA;EACA,eAAA;AAgGZ;AA7FY;EACI,gBAAA;EACA,eAAA;AA+FhB;AA1FQ;EACI,6BAAA;EACA,gBAAA;AA4FZ;AA3FY;EACI,mBAAA;AA6FhB;AAzFI;EACI,kBAAA;AA2FR;AAzFY;EACI,cAAA;EACA,SAAA;EACA,QAAA;AA2FhB;AAvFI;EACI,mBAAA;AAyFR;AAvFI;EACI,eAAA;AAyFR;AAvFI;EACI,6BAAA;AAyFR;AAvFY;EACI,mBAAA;AAyFhB;AArFI;EACI,uBAAA;AAuFR;AArFI;;EAEI,mBAAA;EACA,eAAA;EACA,iCAAA;AAuFR;AF3UI;EEyCJ;IA8MQ,cAAA;EAwFN;EAtFE;IACI,mBAAA;EAwFN;EAtFC;IACE,YAAA;EAwFH;EArFI;IACE,mBAAA;EAuFN;EAnFM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;EAqFV;EAnFM;IACI,kBAAA;IACA,WAAA;EAqFV;EAlFM;IACI,iBAAA;EAoFV;EAnFU;IACI,mBAAA;EAqFd;EAhFc;IACI,4BAAA;IACA,yBAAA;EAkFlB;EA7EU;;IAEI,8BAAA;EA+Ed;EA5EM;;IAEI,mBAAA;EA8EV;EA5EM;IACI,mBAAA;EA8EV;EA3EU;IACI,2BAAA;EA6Ed;EA1EM;IACI,kBAAA;IACA,mBAAA;EA4EV;EA1EM;;IAEI,8BAAA;EA4EV;AACF;AA1EI;EACI,YAAA;AA4ER;AAzEI;EACI,cAAA;AA2ER","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.inputCheckboxLabel{\n    font-family: 'Omnes-ATT-W02', Arial;\n      font-size: 14px;\n  }\n  \n.acc-content {\n    // padding-bottom: 5px;\n    // // padding-left: 20px;\n    // margin-bottom: 8px;\n}\n\n.mediaStop{\n    height:140px;\n    width:251px;\n    margin-bottom: 20px;\n    }\n.accordion {\n        border-bottom: 1px solid color(default, darker);\n        margin-bottom: 60px;\n    }\n\n.tab-nav {\n    \n    width: max-content ;\n  }\n\n@media only screen and (min-width:1024px) and (max-width: 1220px){\n    .tab-nav{\n      .app-tab{\n        .list{\n          a{\n            font-size:1.5rem;\n          }\n        }\n      }\n    }\n}\n@media only screen and (min-width:1221px) and (max-width: 1250px){\n  .tab-nav{\n    .app-tab{\n      .list{\n        a{\n          font-size:1.8rem;\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width:1251px) and (max-width: 1273px){\n  .tab-nav{\n    .app-tab{\n      .list{\n        a{\n          font-size:1.9rem;\n        }\n      }\n    }\n  }\n}\n  \n.page-count{\n}\n\n.accounts-tab {\n  margin: 0 16.66%;\n  // @media only screen and (max-width: 1280px) {\n  //   margin: 0 18%;\n  // }\n  \n  // @media only screen and (min-width: 1281px) and (max-width: 1366px) {\n  //   margin: 0 20%;\n  // }\n//   .acc-content {\n//       margin-bottom: 30px;\n//   }\n\n  h3 {\n    font: 24px 'Omnes-ATT-W02';\n    margin-top: 30px;\n    margin-bottom: 30px;\n    @include respond-to (small){\n      font: 16px 'Omnes-ATT-W02-Medium';\n    }\n  }\n  .icon-arrows-sort-arrow{\n        font-size: 17px !important;\n    }\n    .search {\n        position: relative;\n        input {\n            padding-right: 40px;\n        }\n        .search-icon {\n            cursor: pointer;\n            margin-top: -10px;\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            .icon-controls-magnifyingglass {\n                color: color(default, darker);\n                font-size: 25px;\n                font-weight: bold;\n                margin-right: 3px;\n                margin-top: -2px;\n            }\n            .icon-close {\n                color: color(default, darker);\n                font-size: 25px;\n                font-weight: bold;\n                margin-right: 3px;\n                margin-top: -2px;\n              }\n        }\n    #searchField::-ms-clear{\n      display:none;\n    }\n    }\n\n  .search-label{\n    display: none;\n  }\n\n    .rowdisabled {\n        pointer-events: none;\n    }\n    .box-outer {\n        padding: 0 30px;\n    }\n    .tab-content {\n        padding: 0;\n        h2 {\n            font-size: 3rem;\n            font-weight: normal;\n            margin: 30px 0;\n        }\n        p {\n            margin-bottom: 20px;\n        }\n    }\n    .acc-content {\n        table {\n            margin: 0;\n            tbody:last-child td {\n                border-bottom: 0 !important;\n            }\n        }\n    }\n    tr {\n        th {\n            &:first-child {\n                width: 15%;\n            }\n        }\n    }\n    .accounts {\n        margin-bottom: 30px;\n    }\n    .buttons-section {\n        margin-top: 20px;\n        border-top: 1px solid color(default, dark);\n        padding: 30px 0;\n        .btn-cancel {\n            margin-right: 30px;\n        }\n        @include respond-to (small) {\n            margin-top: 20px;\n        }\n    }\n    .check {\n        margin-bottom: 30px;\n        .checkbox {\n            display: block;\n        }\n    }\n    .error-text {\n        color: color(danger, base);\n        .skin {\n            border: 1px solid color(danger, base);\n        }\n    }\n    .modal-header {\n        margin-bottom: 10px;\n    }\n    .terms-and-conditions {\n        .checkbox {\n            a {\n                color: color(inverse, darker)\n            }\n        }\n        .row {\n            margin-left: 0;\n            margin-right: 0;\n        }\n        .form-group {\n            margin-left: 0;\n            margin-right: 0;\n        }\n        .terms {\n            h1 {\n                margin-top: 30px;\n            }\n        }\n    }\n    .agreement {\n        //border-top: 1px solid color(default, dark);\n        margin-top: 15px; // padding: 30px 0 20px;\n        h2{\n            font-size: 20px;\n          }\n          .attTerms{\n            padding-bottom:10px;\n          }\n        //   .awaitAttTerms{\n        //     color: #5a5a5a;\n        //   }\n        p {\n            margin-bottom: 0;\n            display:inline;\n        }\n        .termsServiceText{\n            p {\n                margin-bottom: 0;\n                display:inline;\n            }\n        }\n    }\n    .signupwithnotab {\n        .agreement {\n            border-top: 1px solid color(default, dark);\n            margin-top: 30px;\n            h3 {\n                margin-bottom: 20px;\n            }\n        }\n    }\n    .signuptabcontainer {\n        position: relative;\n        .pagination {\n            &::after {\n                border: 0 none;\n                height: 0;\n                width: 0;\n            }\n        }\n    }\n    .alert {\n        margin-bottom: 30px;\n    }\n    .fan-profile {\n        cursor: pointer;\n    }\n    .terms-of-service-container {\n        border-top: 1px solid #d2d2d2;\n        .checkbox {\n            &:first-child {\n                margin-bottom: 20px;\n            }\n        }\n    }\n    .ineligible-fans {\n        color: color(danger, base);\n    }\n    .attTerms,\n    .ibmTerms {\n        margin-bottom: 20px;\n        font-size: 16px;\n        font-family: Omnes-ATT-W02,Arial;\n    }\n    @include respond-to (small) {\n        margin: 0 15px;\n\n    .accordion {\n        margin-bottom: 30px;\n    }\n   .tab-nav{\n     width:unset;\n    }\n    .signup-section{\n      .tabContainer{\n        height:max-content;\n      }\n    }\n   \n        .btn-cancel {\n            margin: 20px 0;\n            text-align: center;\n            width: 100%;\n        }\n        .btn {\n            text-align: center;\n            width: 100%;\n        }\n\n        .buttons-section {\n            padding: 20px 0 0;\n            .btn-cancel {\n                margin: 20px 0 30px;\n            }\n        }\n        .tab-nav {\n            .app-tab {\n                .list>a {\n                    padding: 25px 1px !important;\n                    color: #191919 !important;\n                }\n            }\n        }\n        .tab-content {\n            h2,\n            p {\n                margin-bottom: 20px !important;\n            }\n        }\n        .accounts,\n        .check {\n            margin-bottom: 20px;\n        }\n        .form-group {\n            margin-bottom: 20px;\n        }\n        .agreement {\n            p {\n                margin-bottom: 0 !important;\n            }\n        }\n        .grid-table {\n            margin-left: -15px;\n            margin-right: -15px;\n        }\n        .step-indicator,\n        .alert {\n            margin-bottom: 30px !important;\n        }\n    }\n    .search-field{\n        float: right;\n      }\n    \n    .link-to-brief {\n        margin: 20px 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
